import axios from 'axios';
import { _api } from '@/utils/apiAxios';

const state = {
  cmsSettings: {},
};

const getters = {};

const mutations = {
  CMS_SETTINGS_UPATE: (state, payload) => {
    state.cmsSettings = payload;
  },
};

const actions = {
  async SET_CMS_SETTNGS({ rootState, commit }, payload) {
    const url = `${payload}/wp-json/cms-request/v1/get-options/${rootState.settings.selectedLocale.short_code}`;
    delete _api.defaults.headers.common['epos-token'];
    _api.get(url).then(r => {
      if (r.status === 200) {
        commit('CMS_SETTINGS_UPATE', r.data);
      }
    });
  },
};

export const cmsSettings = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
